import CreateBinderForm from 'components/features/create-binder-form';
import HomeLayout from 'layouts/home-layout';
import { useTranslation } from 'react-i18next';

function CreateBinder() {
  const { t } = useTranslation();

  return (
    <HomeLayout title={t('binder.binderRecords')}>
      <CreateBinderForm />
    </HomeLayout>
  );
}

export default CreateBinder;
